import {makeBool} from 'components/forms/locale/utils';
import {isObject} from 'lodash';
import {usePostNewVessel} from './usePostEndpoint';

const diffCheck = (newData, oldData) => {
    // get the new data fields which are different from oldData
    const outData = {};

    Object.entries(newData).forEach(([key, value]) => {
        if (key === 'uscg_official_number' || key === 'imo_number') {
            if (parseInt(value) !== parseInt(oldData[key])) {
                outData[key] = `${value}`;
            }
        } else if (
            [
                'engine_horsepower',
                'tonnage',
                'length_tonnage',
                'width_tonnage',
                'depth_tonnage',
            ].includes(key)
        ) {
            if (parseFloat(value) !== parseFloat(oldData[key])) {
                outData[key] = `${value}`;
            }
        } else if (makeBool(value) !== undefined) {
            // work with truthy values
            if (makeBool(value) !== makeBool(oldData[key])) {
                outData[key] = value;
            }
        } else if (value !== oldData[key]) {
            outData[key] = value;
        }
    });
    return outData;
};

const usePostVesselData = () => {
    const vesselPost = usePostNewVessel();

    const formPost = (newVesselData, oldVesselData) => {
        const diffs =
            isObject(oldVesselData) && Object.keys(oldVesselData).length
                ? diffCheck(newVesselData, oldVesselData)
                : newVesselData;

        if (!oldVesselData?.vessel_id) {
            // always post new vessels
            const postObj = {};
            if (oldVesselData?.external_vessel_id) {
                // backend is picky.. only include key external_vessel_id if it's not null
                postObj.external_vessel_id = oldVesselData?.external_vessel_id;
            }
            vesselPost.post({
                // link this back to the original vessel
                external_vessel_id: oldVesselData?.external_vessel_id,
                new_vessel_info: {
                    ...diffs,
                    // always post these fields with new vessels
                    vessel_type: newVesselData.vessel_type,
                    engine_mode_of_propulsion:
                        newVesselData.engine_mode_of_propulsion,
                },
            });
            return true;
        } else if (Object.keys(diffs).length > 0) {
            // this vessel entry has been edited
            // need to post it in order to use it
            const postObj = {};
            if (oldVesselData?.vessel_id) {
                // backend is picky.. only include key existing_vessel_id if it's not null
                postObj.existing_vessel_id = oldVesselData?.vessel_id;
            }
            vesselPost.post({
                ...postObj,
                new_vessel_info: {
                    ...diffs,
                    vessel_type: newVesselData.vessel_type,
                    engine_mode_of_propulsion:
                        newVesselData.engine_mode_of_propulsion,
                },
            });
            return true;
        } else {
            // existing vessel, and no changes. nothing to post
            return false;
        }
    };

    return {
        formPost,
        submissionInProgress: vesselPost.submissionInProgress,
        result: vesselPost.result,
        error: vesselPost.error,
        reset: vesselPost.reset,
    };
};

export default usePostVesselData;
